import { useFormContext, useWatch } from "react-hook-form"
import { Input } from "../ui/input"
import { Slider } from "../ui/slider"
import FormField from "./FormField"

interface SliderInputProps extends React.ComponentProps<typeof Input> {
  min?: number
  max?: number
  step?: number
  label: string
  name: string
}
function SliderInput({ label, step, name, ...props }: SliderInputProps) {
  const value = useWatch({ name })
  const { setValue } = useFormContext()

  return (
    <div className="flex items-center gap-3">
      <span className="flex-1 text-sm">{label}</span>
      <Slider
        className="w-24"
        step={step}
        {...(props as any)}
        value={[value]}
        onValueChange={(value) => {
          setValue(name, value?.[0])
        }}
      />
      <FormField name={name} valueAsNumber>
        <Input type="number" className={"w-16 [&_input]:bg-input-hover "} size="sm" {...props} />
      </FormField>
    </div>
  )
}

export default SliderInput
